import React from 'react'

import { Box, Typography } from '@material-ui/core'
import { Controller, useFormContext } from 'react-hook-form'

import { GradientSlider } from 'components'

import useThirdPartyManagementStepper from 'hooks/useThirdPartyManagementStepper'

import constants from 'constants/index'
import helpers from 'helpers'

import useStyles from './styles'

const RiskLevelSection = () => {
  const classes = useStyles()
  const { control, setValue, watch } = useFormContext()
  const { isShow, isPreAvaliation, fromCreate } =
    useThirdPartyManagementStepper()

  const { RISKS_LIST } = constants.thirdPartyManagements
  const { STEPS } = constants.tours.thirdPartyManagements

  return (
    <Box
      id={helpers.thirdPartyManegementPartners.getRisksTourStepId({
        STEPS,
        isPreAvaliation,
        fromCreate,
        step: 1,
      })}
    >
      <Typography variant="h6" gutterBottom>
        Nível de Risco
      </Typography>
      <Box className={classes.sliderContainer}>
        <Controller
          as={
            <GradientSlider
              options={RISKS_LIST}
              setControllerValue={setValue}
              name="riskLevel"
              min={0}
              max={4}
              defaultValue={watch('riskLevel')}
              disabled={isShow}
            />
          }
          control={control}
          name="riskLevel"
        />
      </Box>
    </Box>
  )
}

export default RiskLevelSection
